import { render, staticRenderFns } from "./LogoutItem.vue?vue&type=template&id=85cb8a12&scoped=true&"
var script = {}
import style0 from "./LogoutItem.vue?vue&type=style&index=0&id=85cb8a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cb8a12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85cb8a12')) {
      api.createRecord('85cb8a12', component.options)
    } else {
      api.reload('85cb8a12', component.options)
    }
    module.hot.accept("./LogoutItem.vue?vue&type=template&id=85cb8a12&scoped=true&", function () {
      api.rerender('85cb8a12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LogoutItem.vue"
export default component.exports